var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgProductDoors(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 2.25h12a.75.75 0 01.75.75v18a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75V3A.75.75 0 019 2.25zM6 3a3 3 0 013-3h12a3 3 0 013 3v18a3 3 0 01-3 3H9a3 3 0 01-3-3V3zm5.625 5.25v-3h6.75v3h-6.75zm-2.25-4.5a.75.75 0 01.75-.75h9.75a.75.75 0 01.75.75v6a.75.75 0 01-.75.75h-9.75a.75.75 0 01-.75-.75v-6zm2.25 13.5v1.5h6.75v-1.5h-6.75zm-1.5-2.25a.75.75 0 00-.75.75v4.5c0 .414.336.75.75.75h9.75a.75.75 0 00.75-.75v-4.5a.75.75 0 00-.75-.75h-9.75zm10.125-2.25c0 .633-.527 1.125-1.125 1.125A1.11 1.11 0 0118 12.75c0-.598.492-1.125 1.125-1.125.598 0 1.125.527 1.125 1.125z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgProductDoors);
export default ForwardRef;
